import React, { createContext, useState } from "react";

export const prescriptionContext = createContext({});

function MedicineContext({ children }) {
  const [prescriptionStore, setPrescriptionStore] = useState([]);
  const [medicine, setMedicine] = useState({
    prescription: "",
    dosage: "",
    comment: "",
    external: true,
  });
  const [prescriptionStoreTraya, setPrescriptionStoreTraya] = useState([]);
  const [medicineTraya, setMedicineTraya] = useState({
    prescription: "",
    dosage: "",
    comment: "",
  });
  const [prescriptionStoreTest, setPrescriptionStoreTest] = useState([]);
  const [medicineTest, setMedicineTest] = useState({
    test: "",
  });

  const clearPrescriptionStore = () => {
    setPrescriptionStore([]);
    setMedicine({
      prescription: "",
      dosage: "",
      comment: "",
      external: true,
    });
    setPrescriptionStoreTraya([]);
    setMedicineTraya({
      prescription: "",
      dosage: "",
      comment: "",
    });
    setPrescriptionStoreTest([]);
    setMedicineTest({
      test: "",
    })
  };

  const contextValue = {
    prescriptionStore,
    setPrescriptionStore,
    medicine,
    setMedicine,
    prescriptionStoreTraya,
    setPrescriptionStoreTraya,
    medicineTraya,
    setMedicineTraya,
    prescriptionStoreTest,
    setPrescriptionStoreTest,
    medicineTest,
    setMedicineTest,
    clearPrescriptionStore
  };

  return (
    <prescriptionContext.Provider value={contextValue}>
      {children}
    </prescriptionContext.Provider>
  );
}

export default MedicineContext;
